import React, { Component } from 'react'
import Titulo from '../comum/Titulo'
import Autorizacao from '../../security/Autorizacao'
import CampoSelecionarEmpresa from '../layout/CampoSelecionarEmpresa'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { change as changeFieldValue, Field, formValueSelector, reduxForm } from 'redux-form'
import selecionarVeiculoItinerario from '../../actions/itinerario/selecionarVeiculoItinerario';
import { getAdminEmpresa, getGestorEmpresa, getOperadorEmpresa, PERFIL_ADMIN } from '../../security/securityContext'
import limparVeiculoItinerarioSelecionado from '../../actions/itinerario/limparVeiculoItinerarioSelecionado';
import buscarVeiculos from '../../actions/veiculo/buscarVeiculos';
import buscarVeiculosDisponiveis from '../../actions/agendamento-viagem/buscarVeiculosDisponiveis'
import buscarPessoacontratantePorCpfCnpj from '../../actions/pessoa/buscarPessoacontratantePorCpfCnpj';
import SelecaoCidadeAutocomplete from '../layout/SelecaoCidadeAutocomplete';
import selecionarOrigem from '../../actions/origem/selecionarOrigem'
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import ptBR from 'date-fns/locale/pt-BR';
import moment from 'moment'
import {
    apenasLetra, apenasNumero, email, maxTamanhoNome, minTamanhoNome, renderFieldCpfCnpj,
    renderFieldEmail, renderFieldHora, renderFieldKM,
    renderFieldMonetarioLabelEncima, renderFieldSelect, renderFieldTelefone,
    required, requiredSelect, tamanhoHoraMinuto,
    telefone,
    validarCpfCnpjInformado,
    validateHora,
    validateMinutos,
    renderFieldNumber
} from '../../util/inputs'
import selecionarPessoaContratante from '../../actions/pessoa/selecionarPessoaContratante'
import { renderField } from '../../util/arraysUtil'
import { gerarHashForString } from '../../util/stringUtil'
import cadastrarAgendamentoViagem from '../../actions/agendamento-viagem/cadastrarAgendamentoViagem'
import limparVeiculosDisponiveis from '../../actions/agendamento-viagem/limparAgendamentosViagens'
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada'
import { estados } from '../../util/constantsUtil';
import { tamanhoArquivoUpload } from '../../util/applicationContext';
import { showAlertMsg, showErrorMsg, showSuccessMsg } from '../../util/messagesUtil';
import selecionarAgendamentoViagem from '../../actions/agendamento-viagem/selecionarAgendamentoViagem'
import InputMask from 'react-input-mask';
import ModalCalendario from '../ModalCalendario'
import buscarAgrupadoDisponibilidadeVeiculoPorVeiculo from '../../actions/disponibilidade-veiculo/buscarAgrupadoDisponibilidadeVeiculoPorVeiculo'
import $ from 'jquery'
import selecionarAgrupadoDisponibilidadeVeiculo from '../../actions/disponibilidade-veiculo/selecionarAgrupadoDisponibilidadeVeiculo'

registerLocale('pt-BR', ptBR);
setDefaultLocale('pt-BR');

export class PainelCadastroAgendamentoViagem extends Component {

    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.state = {
            dataInicio: null, dataFim: null,
            cpfCnpjContratante: '',
            habilitaCamposContratantePJ: false,
            habilitaCamposContratantePF: false,
            dataPartida: null, dataChegada: null,
            cidadeDestino: [],
            ufNotaFiscal: '',
            roteirosSelecionados: [],
            ordem: 0,
            dataEmissao: null,
            notaFiscalId: null,
            combinedEventsData: []
        }
    }

    componentDidMount() {
        if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
            this.props.selecionarAgrupadoDisponibilidadeVeiculo(null);
            this.props.limparVeiculoItinerarioSelecionado();
            this.props.limparVeiculosDisponiveis();
            this.removerArquivo();
            this.props.buscarVeiculosDisponiveis(this.props.empresaSelecionada.id);
        }

        this.carregarFormulario();

    }

    carregarFormulario() {
        if (this.props.agendamentoViagemSelecionado.veiculo.descricao) {
            this.props.changeFieldValue('formularioPainelCadastroAgendamentoViagem',
                'veiculo', {
                label: `${this.props.agendamentoViagemSelecionado.veiculo.descricao}`,
                value: this.props.agendamentoViagemSelecionado.veiculo
            });
        }

        if (this.props.agendamentoViagemSelecionado.notafiscal) {
            this.props.changeFieldValue('formularioPainelCadastroAgendamentoViagem', 'valorNotaFiscal', this.props.agendamentoViagemSelecionado.notafiscal.valor);
            this.props.changeFieldValue('formularioPainelCadastroAgendamentoViagem', 'urlComprovante', this.props.agendamentoViagemSelecionado.notafiscal.urlImagem);
            this.props.changeFieldValue('formularioPainelCadastroAgendamentoViagem', 'nomeComprovante', this.props.agendamentoViagemSelecionado.notafiscal.nomeImagemNotaFiscal);
            this.props.changeFieldValue('formularioPainelCadastroAgendamentoViagem', 'base64Comprovante', this.props.agendamentoViagemSelecionado.notafiscal.imagemNotaFiscal);
            this.props.changeFieldValue('formularioPainelCadastroAgendamentoViagem', 'numeroNotaFiscal', this.props.agendamentoViagemSelecionado.notafiscal.numero);
            this.props.changeFieldValue('formularioPainelCadastroAgendamentoViagem', 'serieNotaFiscal', this.props.agendamentoViagemSelecionado.notafiscal.serie);
            this.props.changeFieldValue('formularioPainelCadastroAgendamentoViagem', 'ufNotaFiscal', {
                label: this.props.agendamentoViagemSelecionado.notafiscal.uf,
                value: this.props.agendamentoViagemSelecionado.notafiscal.uf
            });

            this.setState({
                notaFiscalId: this.props.agendamentoViagemSelecionado.notafiscal.id,
                dataEmissao: this.props.agendamentoViagemSelecionado.notafiscal.dataEmissao
                    ? moment(this.props.agendamentoViagemSelecionado.notafiscal.dataEmissao).toDate() : null,
                ufNotaFiscal: {
                    label: this.props.agendamentoViagemSelecionado.notafiscal.uf,
                    value: this.props.agendamentoViagemSelecionado.notafiscal.uf
                }
            });
        }

        if (this.props.agendamentoViagemSelecionado.contratante) {
            const contratante = this.props.agendamentoViagemSelecionado.contratante;
            this.props.changeFieldValue('formularioPainelCadastroAgendamentoViagem', 'cpfCnpjContratante', contratante.cpfCnpj);

            if (contratante.tipoPessoa == 'PF' && contratante.cpfCnpj.length > 0) {
                this.setState({ habilitaCamposContratantePF: true });
            } else if (contratante.tipoPessoa == 'PJ' && contratante.cpfCnpj.length > 0) {
                this.setState({ habilitaCamposContratantePJ: true })
            }

            this.preencherCamposContratante(contratante);
        }

        if (this.props.agendamentoViagemSelecionado.roteiros && this.props.agendamentoViagemSelecionado.roteiros.length > 0) {
            const roteiros = this.props.agendamentoViagemSelecionado.roteiros;

            let ordem = 0;
            const roteirosSelecionados = roteiros.sort((a, b) => a.ordem - b.ordem).map(it => {
                ordem = it.ordem;

                return {
                    hash: gerarHashForString(`${it.ordem}-${it.cidade.descricaoUf}-${it.cidade.uf}`),
                    id: it.id,
                    ordem: it.ordem,
                    cidade: it.cidade,
                    pais: 'Brasil',
                    dataPartida: it.dataPartida,
                    horaPartida: it.horaPartida,
                    dataChegada: it.dataChegada,
                    horaChegada: it.horaChegada
                }
            })

            this.setState({ roteirosSelecionados, ordem })
        }

        this.setState({
            dataInicio: this.props.agendamentoViagemSelecionado.dataInicio,
            dataFim: this.props.agendamentoViagemSelecionado.dataFim,
        })

    }

    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps)) {
            this.props.limparVeiculoItinerarioSelecionado();
            this.props.limparVeiculoItinerarioSelecionado();
            this.props.buscarVeiculosDisponiveis(this.props.empresaSelecionada.id);
        }
    }

    preencherCamposContratante(contratante) {
        let pessoaContratante = this.props.pessoaContratante;

        if (contratante) {
            pessoaContratante = contratante;
        }

        this.props.changeFieldValue('formularioPainelCadastroAgendamentoViagem', 'razaoSocial', pessoaContratante.razaoSocial);
        this.props.changeFieldValue('formularioPainelCadastroAgendamentoViagem', 'nomeFantasia', pessoaContratante.nomeFantasia);
        this.props.changeFieldValue('formularioPainelCadastroAgendamentoViagem', 'inscEstadual', pessoaContratante.inscEstadual);
        this.props.changeFieldValue('formularioPainelCadastroAgendamentoViagem', 'nome', pessoaContratante.nome);

        this.props.changeFieldValue('formularioPainelCadastroAgendamentoViagem', 'nomeContratante', pessoaContratante.nome);
        this.props.changeFieldValue('formularioPainelCadastroAgendamentoViagem', 'email', pessoaContratante.email);
        this.props.changeFieldValue('formularioPainelCadastroAgendamentoViagem', 'telefone', pessoaContratante.telefone);

    }

    zerar() {
        this.limparCamposContratante();
        this.setState({ cpfCnpjContratante: '' });
        this.props.selecionarPessoaContratante({});
    }

    limparCamposContratante() {
        this.props.changeFieldValue('formularioPainelCadastroAgendamentoViagem', 'razaoSocial', '');
        this.props.changeFieldValue('formularioPainelCadastroAgendamentoViagem', 'nomeFantasia', '');
        this.props.changeFieldValue('formularioPainelCadastroAgendamentoViagem', 'inscEstadual', '');
        this.props.changeFieldValue('formularioPainelCadastroAgendamentoViagem', 'nome', '');

        this.props.changeFieldValue('formularioPainelCadastroAgendamentoViagem', 'nomeContratante', '');
        this.props.changeFieldValue('formularioPainelCadastroAgendamentoViagem', 'email', '');
        this.props.changeFieldValue('formularioPainelCadastroAgendamentoViagem', 'telefone', '');

        this.setState({ habilitaCamposContratantePJ: false, habilitaCamposContratantePF: false });
    }

    handleSelecionarVeiculo(evento) {
        this.props.selecionarVeiculoItinerario(evento);
    }

    exibirCalendarioRoteiro(inicio) {
        let data;

        let minDate = new Date();
        minDate.setDate(minDate.getDate() - 5)
        if (inicio) {
            if (this.state.dataPartida) {
                data = moment(this.state.dataPartida)
                    .toDate()
            }
        } else {
            minDate = moment(this.state.dataPartida)
                .toDate();
            if (this.state.dataChegada) {
                data = moment(this.state.dataChegada)
                    .toDate()
            }
        }
        return (
            <div>
                <div className="linha">
                    <DatePicker
                        className='form-control col-md-12'
                        value={data}
                        locale="pt-BR"
                        minDate={minDate}
                        selected={data}
                        startDate={moment(this.state.dataPartida)
                            .toDate()}
                        endDate={moment(this.state.dataChegada)
                            .toDate()}
                        onChange={date => this.selecionarDataRoteiro(date, inicio)}
                        dateFormat="dd/MM/yyyy"
                        customInput={<InputMask mask="99/99/9999" />}
                    />
                </div>
            </div>
        )
    }

    selecionarDataRoteiro(data, inicio) {
        if (inicio) {
            if (data) {
                this.setState({ dataPartida: moment(data).format('YYYY-MM-DD') });
            } else {
                this.setState({ dataPartida: null });
            }
        } else {
            if (data) {
                this.setState({ dataChegada: moment(data).format('YYYY-MM-DD') });
            } else {
                this.setState({ dataChegada: null });
            }
        }
    }

    exibirCalendario(inicio) {
        let data;

        let minDate = new Date();
        minDate.setDate(minDate.getDate())
        if (inicio) {
            if (this.state.dataInicio) {
                data = moment(this.state.dataInicio)
                    .toDate()
            }
        } else {
            minDate = moment(this.state.dataInicio)
                .add(1, 'days')
                .toDate();
            if (this.state.dataFim) {
                data = moment(this.state.dataFim)
                    .toDate()
            }
        }
        return (
            <div>
                <div className="linha">
                    <DatePicker
                        className='form-control col-md-12'
                        value={data}
                        locale="pt-BR"
                        minDate={minDate}
                        selected={data}
                        startDate={moment(this.state.dataInicio)
                            .toDate()}
                        endDate={moment(this.state.dataFim)
                            .toDate()}
                        disabled={!inicio && !this.state.dataInicio}
                        onChange={date => this.selecionarData(date, inicio)}
                        dateFormat="dd/MM/yyyy"
                        withPortal
                    />
                </div>
            </div>
        )
    }

    selecionarData(data, inicio) {
        if (inicio) {
            this.setState({ dataInicio: data, dataFim: null })
        } else {
            this.setState({ data, dataFim: data })
        }
    }

    buscarCalendarioAgrupadoDisponibilidadeVeiculo(e) {
        e.preventDefault();
        const veiculoId = this.props.veiculoItinerarioSelecionado.value && this.props.veiculoItinerarioSelecionado.value.id 
            ? this.props.veiculoItinerarioSelecionado.value.id 
            : this.props.agendamentoViagemSelecionado.veiculo.id;

        if (veiculoId) {
            this.props.buscarAgrupadoDisponibilidadeVeiculoPorVeiculo(this.props.empresaSelecionada.id, veiculoId).then((response) => {
                if (response.payload.status == 200) {
                    const agrupadoDisponibilidades = response.payload.data;
                    this.props.selecionarAgrupadoDisponibilidadeVeiculo(agrupadoDisponibilidades);
                    this.preencherModalCalendario(agrupadoDisponibilidades);
                    $('#modalCalendario').modal('show');
                }
            });
        } else {
            showAlertMsg('Selecione o veículo');
        }
    }

    preencherModalCalendario(valor) {
        let bloqueios = [];
        let agendamentoViagem = [];
        let disponibilidadesVeiculo = [];

        const dv = valor.disponibilidadeVeiculo;
        if (dv && dv.length > 0) {
            const eventos = dv.map(it => {
                const bloqueioDisponibilidadeVeiculo = it.bloqueioDisponibilidadeVeiculo;
                if (bloqueioDisponibilidadeVeiculo && bloqueioDisponibilidadeVeiculo.length > 0) {
                    bloqueios = bloqueioDisponibilidadeVeiculo.map(b => {
                        return {
                            title: <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>,
                            start: moment(b.dataInicio).toDate(),
                            end: moment(b.dataFim).add(1, 'day').toDate(),
                            tipo: 'bloqueado',
                            legenda: 'bloqueado'
                        }
                    })
                }

                return {
                    title: <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>,
                    start: moment(it.dataInicio).toDate(),
                    end: moment(it.dataFim).add(1, 'day').toDate(),
                    tipo: 'disponivel',
                    legenda: 'disponivel'
                }

            })

            disponibilidadesVeiculo = [...eventos];
        }

        const ag = valor.agendamentoViagem;
        if (ag && ag.length > 0) {
            agendamentoViagem = ag.map(a => {
                return {
                    title: <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>,
                    start: moment(a.dataInicio).toDate(),
                    end: moment(a.dataFim).add(1, 'day').toDate(),
                    tipo: 'comAgendamento',
                    legenda: 'Com Agendamento'
                }
            })
        }


        const todosEventos = [...disponibilidadesVeiculo, ...bloqueios, ...agendamentoViagem];
        this.setState({
            combinedEventsData: todosEventos
        })
    }

    buscarPessoacontratante(e) {
        e.preventDefault();
        this.setState({ cpfCnpjContratante: this.props.cpfCnpjContratante });
        this.limparCamposContratante();
        this.props.buscarPessoacontratantePorCpfCnpj(this.props.cpfCnpjContratante)
            .then(() => {
                const cpfCnpj = apenasNumero(this.props.cpfCnpjContratante);
                const pj = (this.props.pessoaContratante && this.props.pessoaContratante.tipoPessoa == 'PJ' || cpfCnpj && cpfCnpj.length == 14);
                const pf = (this.props.pessoaContratante && this.props.pessoaContratante.tipoPessoa == 'PF' || cpfCnpj && cpfCnpj.length == 11);

                if (pj) {
                    this.setState({ habilitaCamposContratantePJ: pj, habilitaCamposContratantePF: false });
                }

                if (pf) {
                    this.setState({ habilitaCamposContratantePF: pf, habilitaCamposContratantePJ: false });
                }

                this.preencherCamposContratante();
            })
    }

    exibePessoaContratante() {
        return (
            <>
                {this.state.habilitaCamposContratantePJ && <>
                    <div className='form-row col-12'>
                        <div className="col-12 col-sm-4 col-md-4">
                            <Field name="razaoSocial" type="text" component={renderField} label="Razão social:"
                                css="form-control" readOnly={false} />
                        </div>
                        <div className="col-12 col-sm-4 col-md-4">
                            <Field name="inscEstadual" type="text" component={renderField} label="Inscrição Estadual:"
                                css="form-control" />
                        </div>
                    </div>
                    <div className='form-row col-12'>
                        <div className="col-12 col-sm-4 col-md-4">
                            <Field name="nome" type="text" component={renderField} label="Nome:"
                                validate={[required]}
                                css="form-control" readOnly={false} />
                        </div>
                        <div className="col-12 col-sm-4 col-md-4">
                            <Field name="nomeFantasia" type="text" component={renderField} label="Nome fantasia:"
                                css="form-control" readOnly={false} />
                        </div>
                    </div>
                </>}
                {this.state.habilitaCamposContratantePF && <>
                    <div className='form-row col-12'>
                        <div className='col-12 col-sm-4 col-md-4'>
                            <Field name='nomeContratante' type="text" component={renderField} minLength='2' label='Nome completo'
                                validate={[required, apenasLetra, minTamanhoNome, maxTamanhoNome]}
                                css="form-control" readOnly={false} />
                        </div>
                    </div>
                </>}
                {(this.state.habilitaCamposContratantePJ || this.state.habilitaCamposContratantePF) && <><div className='form-row col-12'>
                    <div className="fcol-12 col-sm-4 col-md-4">
                        <Field name="email" type="email" validate={[required, email]}
                            component={renderFieldEmail} label="E-mail:"
                            css="form-control" />
                    </div>
                    <div className="col-12 col-sm-4 col-md-4">
                        <Field name="telefone" type="text" validate={[required, telefone]}
                            component={renderFieldTelefone}
                            css="form-control" label="Telefone" />
                    </div>
                </div></>}

            </>
        )

    }

    selecionarOrigem(origem) {
        this.props.selecionarOrigem(origem);
    }

    exibirCampoBusca() {
        return (<React.Fragment>
            <div className="input-group mb-3 mt-3">
                <div className="col-12 col-sm-12 col-md-3 mb-3">
                    <SelecaoCidadeAutocomplete limparViagens={this.limpaCidadesSelecionadas.bind(this)}
                        name='pesquisaOrigem'
                        placeholder='Pequise a Cidade'
                        selecionarCidade={this.selecionarOrigem.bind(this)}
                        value={this.props.origem}
                    />
                </div>

                <Field name="origem" type="hidden" component={renderField} css="form-control col-md-12" />
            </div>
        </React.Fragment>)
    }

    limpaCidadesSelecionadas(sentido) {
        if (sentido === 'pesquisaOrigem') {
            this.selecionarOrigem(null)
        }
    }

    exibirRoteirosSelecionados() {
        return (
            <table className="table table-sm table-bordered">
                <thead>
                    <tr className='text-center'>
                        <th colSpan='8'>Roteiros</th>
                    </tr>
                    <tr>
                        <th>Ordem</th>
                        <th>País</th>
                        <th>UF</th>
                        <th>Estado</th>
                        <th>Cidade</th>
                        <th>Data Chegada</th>
                        <th>Data Partida</th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    {!this.state.roteirosSelecionados || this.state.roteirosSelecionados.length === 0 ?
                        <tr className="alert alert-warning text-center mt-4" role="alert">
                            <td colSpan='8'>Nenhuma Roteiro Viagem selecionado.
                            </td>
                        </tr>
                        :
                        this.state.roteirosSelecionados
                            .map((roteiro, i) => <tr key={i}>
                                <td>
                                    {roteiro.ordem}
                                </td>
                                <td>{roteiro.pais}</td>
                                <td>{roteiro.cidade.uf}</td>
                                <td>{roteiro.cidade.descricaoUf}</td>
                                <td>{roteiro.cidade.nome}</td>
                                <td>{roteiro.dataChegada ? `${moment(roteiro.dataChegada).format('DD/MM/YYYY')}` : ''} {roteiro.horaChegada}</td>
                                <td>{roteiro.dataPartida ? `${moment(roteiro.dataPartida).format('DD/MM/YYYY')}` : ''} {roteiro.horaPartida}</td>
                                <td className='text-center' style={{ cursor: 'pointer', color: 'red' }}>
                                    <div
                                        onClick={() => this.removerRoteiroSelecionada(roteiro)}
                                    >Remover
                                    </div>
                                </td>
                            </tr>)}
                </tbody>
            </table>
        )
    }

    removerRoteiroSelecionada(roteiro) {
        this.setState({ roteirosSelecionados: this.state.roteirosSelecionados.filter(it => it.hash != roteiro.hash), ordem: this.state.ordem != 0 ? this.state.ordem - 1 : 0 });
    }

    adicionarRoteiro(e) {
        e.preventDefault();
        const ordem = this.state.ordem + 1;

        if (!this.props.origem) {
            showErrorMsg('O campo cidade não foi informado');
            return;
        }

        const roteiro = {
            hash: gerarHashForString(`${ordem}-${this.props.origem.descricaoUf}-${this.props.origem.uf}`),
            id: null,
            ordem: ordem,
            cidade: this.props.origem,
            pais: 'Brasil',
            dataPartida: this.state.dataPartida,
            horaPartida: this.props.horaPartida,
            dataChegada: this.state.dataChegada,
            horaChegada: this.props.horaChegada,

        }

        this.setState({ ordem });

        if (this.state.roteirosSelecionados.filter(it => it.hash === roteiro.hash).length === 0) {
            const roteiros = this.state.roteirosSelecionados;
            roteiros.push(roteiro);
            this.setState({ roteirosSelecionados: roteiros, dataPartida: null, dataChegada: null });

            this.props.changeFieldValue('formularioPainelCadastroAgendamentoViagem', 'pesquisaOrigem', '');
            this.props.changeFieldValue('formularioPainelCadastroAgendamentoViagem', 'origem', '');
            this.props.changeFieldValue('formularioPainelCadastroAgendamentoViagem', 'horaPartida', '');
            this.props.changeFieldValue('formularioPainelCadastroAgendamentoViagem', 'horaChegada', '');

        }

    }

    handleEstadoUf = (uf) => {
        this.setState({
            ufNotaFiscal: uf
        })
    };

    removerArquivo() {
        this.props.changeFieldValue('formularioPainelCadastroAgendamentoViagem',
            'base64Comprovante', null);
        this.props.changeFieldValue('formularioPainelCadastroAgendamentoViagem',
            'nomeComprovante', null);
        this.props.changeFieldValue('formularioPainelCadastroAgendamentoViagem',
            'urlComprovante', null);
    }

    exibirRemoverComprovante() {
        return (<button type="button" className="btn btn-editar"
            title='Remover'
            onClick={() => this.removerArquivo()}>
            <i className="material-icons nav-icon" style={{
                color: 'red'
            }}>&#xe14c;</i>
        </button>)
    }

    exibirBaixarComprovante() {
        if (this.props.urlComprovante) {
            return (
                <button type="button" className="btn btn-editar"
                    title='Baixar'
                    onClick={() => window.open(this.props.urlComprovante, '_blank')}>
                    <i className="material-icons nav-icon" style={{
                        color: '#fa8d42'
                    }}>&#xe2c0;</i>
                </button>)
        }
    }

    exibirAnexar() {
        if (this.props.base64Comprovante || this.props.urlComprovante) {
            return (
                <div className="row align-items-center mt-2">
                    <div className='col-12 label-cancelamento'>
                        <label>Comprovante:</label>
                    </div>
                    <div className='ml-4'>{this.props.nomeComprovante}</div>
                    {this.exibirRemoverComprovante()}
                    {this.exibirBaixarComprovante()}
                </div>
            )
        }

        return (
            <>
                <div className='input-wrapper mt-3'>
                    <label className='btn-laranja' htmlFor='input-file'>
                        <div className='row align-items-center'>
                            <i className="material-icons aberto">&#xe2c3;</i>
                            <strong className='ml-2'>Anexar nota fiscal</strong>
                        </div>
                    </label>
                    <input id='input-file' type='file' value='' accept="image/png,image/jpeg,application/pdf"
                        onChange={this.handleChange.bind(this)} />
                </div><label style={{ fontSize: 'smaller' }}>
                    * Tamanho máximo permitido : 20 MB
                </label>
            </>
        )

    }

    handleChange(event) {
        const file = event.target.files[0];
        if (/\.(jpe?g|png|pdf)$/i.test(file.name) === false) {
            return
        }
        if (file.size > tamanhoArquivoUpload) {
            showErrorMsg('Tamanho do arquivo excede 20 MB');
            return
        }
        this.converterParaBase64(file)
    }

    converterParaBase64(file) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            this.props.changeFieldValue('formularioPainelCadastroAgendamentoViagem',
                'base64Comprovante', reader.result);
            this.props.changeFieldValue('formularioPainelCadastroAgendamentoViagem',
                'nomeComprovante', file.name);
        }.bind(this);
    }

    selecionarDataEmissao(date) {
        if (date) {
            this.setState({ dataEmissao: date });
        } else {
            this.setState({ dataEmissao: null });
        }
    }

    montarParamentos() {
        let notaFiscal = null;

        if (this.state.notaFiscalId
            || this.state.ufNotaFiscal.value || this.props.dataEmissao || this.props.valorNotaFiscal
            || this.props.numeroNotaFiscal || this.props.serieNotaFiscal) {
            notaFiscal = {
                id: this.state.notaFiscalId ? this.state.notaFiscalId : null,
                uf: this.state.ufNotaFiscal ? this.state.ufNotaFiscal.value : null,
                dataEmissao: this.state.dataEmissao,
                valor: this.props.valorNotaFiscal ? this.props.valorNotaFiscal.replace('R$', '') : 0,
                numero: this.props.numeroNotaFiscal,
                serie: this.props.serieNotaFiscal,
                base64NotaFiscal: this.props.base64Comprovante,
                urlComprovante: this.props.urlComprovante,
                nomeComprovante: this.props.nomeComprovante
            };
        }

        return {
            id: this.props.agendamentoViagemSelecionado.id ? this.props.agendamentoViagemSelecionado.id : null,
            empresaId: this.props.empresaSelecionada.id,
            dataInicio: this.state.dataInicio,
            dataFim: this.state.dataFim,
            veiculoId: this.props.veiculoItinerarioSelecionado.value ? this.props.veiculoItinerarioSelecionado.value.id : null,
            contratante: (this.state.habilitaCamposContratantePF || this.state.habilitaCamposContratantePJ) ? {
                tipoPessoa: this.state.habilitaCamposContratantePF ? 'PF' : 'PJ',
                cpfCnpj: this.props.cpfCnpjContratante,
                nome: this.state.habilitaCamposContratantePF ? this.props.nomeContratante : this.props.nome,
                email: this.props.email,
                telefone: this.props.telefone,
                nomeFantasia: this.props.nomeFantasia,
                razaoSocial: this.props.razaoSocial,
                inscEstadual: this.props.inscEstadual,
            } : null,
            roteiros: this.state.roteirosSelecionados.map(it => {
                return {
                    id: it.id,
                    ordem: it.ordem,
                    cidadeId: it.cidade.id,
                    dataPartida: it.dataPartida,
                    horaPartida: it.horaPartida,
                    dataChegada: it.dataChegada,
                    horaChegada: it.horaChegada
                }
            }),
            quilometragem: this.props.quilometragem,
            valorTotal: this.props.valorTotal.replace('R$', ''),
            valorUnitario: this.props.valorUnitario.replace('R$', ''),
            notaFiscal
        }
    }

    submit() {
        const agendamentoViagem = this.montarParamentos();
        this.props.cadastrarAgendamentoViagem(agendamentoViagem)
            .then(() => {
                showSuccessMsg('O agendamento da viagem foi salvo com sucesso!');
                this.props.history.push('/painel-agendamento-viagem');
            });
    }

    apresentarFormulario() {
        if (this.props.agendamentoViagemSelecionado.id) {
            return true;
        } else {
            return this.props.veiculosDisponiveis.length > 0;
        }
    }

    render() {
        const { handleSubmit, invalid, submitting } = this.props;

        return (
            <div>
                <div className="row internas">
                    <Titulo texto={`Painel ${this.props.agendamentoViagemSelecionado.id ? 'Edição' : 'Cadastro'} Agendamento`} urlRetorno="/painel-agendamento-viagem" />
                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                        <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                            <ul className="nav navbar-nav ml-auto opcoes-menu menu-desktop">
                                <li className="nav-item dropdown nome-empresa">
                                    <div className='col-md-6'>
                                        <CampoSelecionarEmpresa />
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </Autorizacao>
                </div>
                <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                    getGestorEmpresa(this.props.empresaSelecionada.id),
                    getAdminEmpresa(this.props.empresaSelecionada.id),
                    getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                    <div>
                        <form onSubmit={handleSubmit(this.submit)}>
                            {this.apresentarFormulario() ? <>
                                <fieldset className="scheduler-border">
                                    <legend className="scheduler-border">Veículos</legend>
                                    <div className='form-row col-12'>
                                        <div className="col-12 col-sm-4 col-md-4">
                                            <Field name='veiculo'
                                                options={this.props.veiculosDisponiveis.map(elemento => ({
                                                    descricao: elemento.descricao,
                                                    nome: elemento
                                                }))}
                                                component={renderFieldSelect}
                                                label="Veículo"
                                                disabled={this.props.agendamentoViagemSelecionado.veiculo.id}
                                                placeholder='Selecione um veículo' validate={requiredSelect}
                                                onChange={(e) => this.handleSelecionarVeiculo(e)} />
                                        </div>
                                    </div>

                                    <div className='form-row col-12'>
                                        <div className="col-12 col-sm-4 col-md-4">
                                            <button type="button" className="btn btn-editar " title='Calendário Disponibilidade Veículo'
                                                onClick={(e) => this.buscarCalendarioAgrupadoDisponibilidadeVeiculo(e)}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-calendar" viewBox="0 0 16 16">
                                                    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
                                                </svg> Calendário
                                            </button>
                                        </div>
                                    </div>

                                    <div className='form-row col-12'>
                                        <div className="col-12 col-sm-4 col-md-4">
                                            <label>Data de início</label>
                                            {this.exibirCalendario(true)}
                                        </div>
                                        <div className="col-12 col-sm-4 col-md-4">
                                            <label>Data fim</label>
                                            {this.exibirCalendario()}
                                        </div>
                                    </div>
                                </fieldset>

                                <fieldset className="scheduler-border">
                                    <legend className="scheduler-border">Informações básicas</legend>
                                    <div className='form-row col-12'>
                                        <div className='form-row col-12 col-sm-9 col-md-9 mt-2'>
                                            <div className="col-12 col-sm-3 col-md-3">
                                                <Field name='valorTotal' validate={[required]} component={renderFieldMonetarioLabelEncima} className="form-control" label="Valor Total" />
                                            </div>

                                            <div className="col-12 col-sm-3 col-md-3">
                                                <Field name='valorUnitario' validate={[required]} component={renderFieldMonetarioLabelEncima} className="form-control" label="Valor Unitário" />
                                            </div>

                                            <div className='col-12 col-sm-3 col-md-2'>
                                                <Field name="quilometragem" component={renderFieldKM} label="Quilometragem:"
                                                    css="form-control" readOnly={false} />
                                            </div>
                                        </div>
                                    </div>

                                </fieldset>

                                <fieldset className="scheduler-border">
                                    <legend className="scheduler-border">Informações do Contratante</legend>
                                    <div className='form-row col-12 mb-2'>
                                        <div className='col-12-col-sm-4 col-md-3'>
                                            <Field name='cpfCnpjContratante' type="text" component={renderFieldCpfCnpj} label="CNPJ/CPF do Contratante:" validate={[validarCpfCnpjInformado]}
                                                css="form-control" readOnly={false} onFocus={() => this.zerar()} />
                                        </div>
                                        <div className='col-2 col-sm-2 col-md-2' style={{ display: 'flex', alignItems: 'end' }}>
                                            <button className='btn btn-laranja btn-sm ml-2 mt-auto'
                                                onClick={(e) => this.buscarPessoacontratante(e)}
                                                disabled={apenasNumero(this.props.cpfCnpjContratante).length !== 11 && apenasNumero(this.props.cpfCnpjContratante).length !== 14}>
                                                <i className="material-icons">&#xe8b6;</i>
                                            </button>
                                        </div>
                                    </div>
                                    {this.exibePessoaContratante()}
                                </fieldset>

                                <fieldset className="scheduler-border">
                                    <legend className="scheduler-border">Roteiro de Viagem</legend>
                                    {this.exibirCampoBusca()}

                                    <div className='form-row col-12'>
                                        <div className="col-12 col-sm-2 col-md-2">
                                            <label className='mt-2'>Data da partida</label>
                                            {this.exibirCalendarioRoteiro(true)}
                                        </div>
                                        <div className="col-6 col-sm-2 col-md-2">
                                            <Field name="horaPartida" type="texto" component={renderFieldHora}
                                                label='Hora de partida'
                                                css="form-control col-md-12" readOnly={false}
                                                validate={[validateMinutos, validateHora, tamanhoHoraMinuto]} />
                                        </div>
                                        {this.state.roteirosSelecionados.length > 0 && <><div className="col-12 col-sm-2 col-md-2">
                                            <label className='mt-2'>Data da chegada</label>
                                            {this.exibirCalendarioRoteiro()}
                                        </div>
                                            <div className="col-6 col-sm-2 col-md-2">
                                                <Field name="horaChegada" type="texto" component={renderFieldHora}
                                                    label='Hora de chegada'
                                                    css="form-control col-md-12" readOnly={false}
                                                    validate={[validateMinutos, validateHora, tamanhoHoraMinuto]} />
                                            </div></>}

                                    </div>
                                    <div className="col-12 col-sm-12 col-md-12 mt-3 mb-3">
                                        <button className="btn btn-sm btn-laranja"
                                            onClick={(e) => this.adicionarRoteiro(e)}>Incluir
                                        </button>
                                    </div>

                                    <div className="col-12 col-sm-12 col-md-10 mt-2">
                                        <div className="lista-table">
                                            {this.exibirRoteirosSelecionados()}
                                        </div>
                                    </div>
                                </fieldset>

                                <fieldset className="scheduler-border">
                                    <legend className="scheduler-border">Nota Fiscal</legend>
                                    <div className='form-row col-12 mb-2'>
                                        <div className='col-12-col-sm-4 col-md-3'>
                                            <Field name="numeroNotaFiscal" type="text" component={renderFieldNumber}
                                                formatacao='#########'
                                                readOnly={false}
                                                label="Numero:"
                                                css="form-control" />
                                        </div>
                                        <div className='col-12-col-sm-1 col-md-1'>
                                            <Field name="serieNotaFiscal" type="text" component={renderFieldNumber}
                                                formatacao='###'
                                                readOnly={false}
                                                label="N° Serie:"
                                                css="form-control" />
                                        </div>
                                        <div className="col-12 col-sm-3 col-md-3">
                                            <Field name='ufNotaFiscal'
                                                options={estados.map(elemento => ({
                                                    descricao: elemento.uf,
                                                    nome: elemento.uf
                                                }))}
                                                component={renderFieldSelect}
                                                label="UF:"
                                                placeholder='Selecione a UF'
                                                onChange={(e) => this.handleEstadoUf(e)} />
                                        </div>
                                    </div>
                                    <div className='form-row col-12 col-sm-9 col-md-9 mt-2'>
                                        <div className="col-12 col-sm-2 col-md-2">
                                            <label className='mt-2'>Data Emissão:</label>
                                            <DatePicker
                                                className='form-control col-md-12'
                                                value={this.state.dataEmissao}
                                                locale="pt-BR"
                                                minDate={new Date()}
                                                selected={this.state.dataEmissao && moment(this.state.dataEmissao)
                                                    .toDate()}
                                                onChange={date => this.selecionarDataEmissao(date)}
                                                dateFormat="dd/MM/yyyy"
                                                customInput={<InputMask mask="99/99/9999" />}
                                            />
                                        </div>
                                        <div className="col-12 col-sm-3 col-md-3">
                                            <Field name='valorNotaFiscal' component={renderFieldMonetarioLabelEncima} className="form-control" label="Valor:" />
                                        </div>
                                    </div>

                                    <div className='col-12 col-sm-12 col-md-12 mt-2'>
                                        {this.exibirAnexar()}
                                    </div>
                                </fieldset>

                                <div className="modal-footer">
                                    <button type="submit"
                                        disabled={invalid || submitting || (
                                            !this.props.agendamentoViagemSelecionado.id && (!this.state.dataInicio || !this.state.dataFim)
                                        ) || this.state.roteirosSelecionados.length == 0}
                                        className="btn btn-laranja">Salvar
                                    </button>
                                </div>
                            </> : 'Não possui calendário disponibilidade de veículo'}
                        </form>
                        <ModalCalendario combinedEventsData={this.state.combinedEventsData} />
                    </div>
                </Autorizacao>

            </div >
        )
    }
}

export function mapStateToProps(state) {
    return {
        initialValues: {
            valorTotal: state.agendamentoViagemSelecionado.valorTotal,
            valorUnitario: state.agendamentoViagemSelecionado.valorUnitario,
            quilometragem: state.agendamentoViagemSelecionado.quilometragem,
        },
        empresaSelecionada: state.empresaSelecionada,
        agendamentoViagemSelecionado: state.agendamentoViagemSelecionado,
        veiculos: state.veiculos.veiculos,
        veiculoItinerarioSelecionado: state.veiculoItinerarioSelecionado,
        veiculosDisponiveis: state.veiculosDisponiveis,
        pessoaContratante: state.pessoaContratante,
        cpfCnpjContratante: formValueSelector('formularioPainelCadastroAgendamentoViagem')(state, 'cpfCnpjContratante'),
        nomeFantasia: formValueSelector('formularioPainelCadastroAgendamentoViagem')(state, 'nomeFantasia'),
        razaoSocial: formValueSelector('formularioPainelCadastroAgendamentoViagem')(state, 'razaoSocial'),
        nomeContratante: formValueSelector('formularioPainelCadastroAgendamentoViagem')(state, 'nomeContratante'),
        inscEstadual: formValueSelector('formularioPainelCadastroAgendamentoViagem')(state, 'inscEstadual'),
        nome: formValueSelector('formularioPainelCadastroAgendamentoViagem')(state, 'nome'),
        email: formValueSelector('formularioPainelCadastroAgendamentoViagem')(state, 'email'),
        telefone: formValueSelector('formularioPainelCadastroAgendamentoViagem')(state, 'telefone'),
        dataPartida: formValueSelector('formularioPainelCadastroAgendamentoViagem')(state, 'dataPartida'),
        horaPartida: formValueSelector('formularioPainelCadastroAgendamentoViagem')(state, 'horaPartida'),
        dataChegada: formValueSelector('formularioPainelCadastroAgendamentoViagem')(state, 'dataChegada'),
        horaChegada: formValueSelector('formularioPainelCadastroAgendamentoViagem')(state, 'horaChegada'),
        valorTotal: formValueSelector('formularioPainelCadastroAgendamentoViagem')(state, 'valorTotal'),
        valorUnitario: formValueSelector('formularioPainelCadastroAgendamentoViagem')(state, 'valorUnitario'),
        quilometragem: formValueSelector('formularioPainelCadastroAgendamentoViagem')(state, 'quilometragem'),
        origem: state.origem,
        urlComprovante: formValueSelector('formularioPainelCadastroAgendamentoViagem')(state, 'urlComprovante'),
        nomeComprovante: formValueSelector('formularioPainelCadastroAgendamentoViagem')(state, 'nomeComprovante'),
        base64Comprovante: formValueSelector('formularioPainelCadastroAgendamentoViagem')(state, 'base64Comprovante'),
        numeroNotaFiscal: formValueSelector('formularioPainelCadastroAgendamentoViagem')(state, 'numeroNotaFiscal'),
        dataEmissao: formValueSelector('formularioPainelCadastroAgendamentoViagem')(state, 'dataEmissao'),
        valorNotaFiscal: formValueSelector('formularioPainelCadastroAgendamentoViagem')(state, 'valorNotaFiscal'),
        serieNotaFiscal: formValueSelector('formularioPainelCadastroAgendamentoViagem')(state, 'serieNotaFiscal')
    }
}

export default withRouter(connect(mapStateToProps, {
    buscarVeiculos,
    buscarVeiculosDisponiveis,
    selecionarVeiculoItinerario,
    limparVeiculoItinerarioSelecionado,
    buscarPessoacontratantePorCpfCnpj,
    selecionarPessoaContratante,
    selecionarOrigem,
    cadastrarAgendamentoViagem,
    limparVeiculosDisponiveis,
    selecionarAgendamentoViagem,
    changeFieldValue,
    buscarAgrupadoDisponibilidadeVeiculoPorVeiculo,
    selecionarAgrupadoDisponibilidadeVeiculo
})(
    reduxForm({
        form: 'formularioPainelCadastroAgendamentoViagem',
    })(PainelCadastroAgendamentoViagem)
))
